import { http as atsHttp } from '@/lib/ats-https';

export interface DarwinboxFormField {
  id: string;
  label: string;
  type: 'string' | 'date' | 'enum';
  required: boolean;
  format?: string;
  options?: string[];
  value: string | null;
}

interface GetFormParams {
  applicationId: string | number;
  integrationType: string;
}

const getDarwinboxEmployeeForm = async ({
  applicationId,
  integrationType,
}: GetFormParams): Promise<DarwinboxFormField[]> => {
  // Match the existing string-concat pattern used by other HRIS endpoints
  // (see hris_field_mappings) so BE sees the unencoded integration_type.
  const response = await atsHttp.get(
    `/ats_applications/${applicationId}/hris_employees/new?integration_type=${integrationType}`
  );
  return response?.data?.fields || [];
};

export const DARWINBOX_HRIS_API_SERVICE = {
  getDarwinboxEmployeeForm,
};
